import { defineAsyncComponent } from 'vue';

const FAResultDeleteDetail = defineAsyncComponent(() => import('@/views/assetQLTS/popup/FAResultDeleteDetail.vue'));

const FAVoucherIncreament = defineAsyncComponent(() =>
  import('@/views/assetQLTS/fAVoucherIncreament/FAVoucherIncreament.vue')
);

const FAVoucherIncreamentDetail = defineAsyncComponent(() =>
  import('@/views/assetQLTS/fAVoucherIncreament/FAVoucherIncreamentDetail.vue')
);

const FAVoucherIncreamentResult = defineAsyncComponent(() =>
  import('@/views/assetQLTS/fAVoucherIncreament/FAVoucherIncreamentResult.vue')
);

const FAVoucherDepreciation = defineAsyncComponent(() =>
  import('@/views/assetQLTS/fAVoucherDepreciation/FAVoucherDepreciation.vue')
);

const FAVoucherDepreciationDetail = defineAsyncComponent(() =>
  import('@/views/assetQLTS/fAVoucherDepreciation/FAVoucherDepreciationDetail.vue')
);

const FAVoucherDepreciate = defineAsyncComponent(() =>
  import('@/views/assetQLTS/fAVoucherDepreciate/FAVoucherDepreciate.vue')
);

const FAVoucherDepreciateDetail = defineAsyncComponent(() =>
  import('@/views/assetQLTS/fAVoucherDepreciate/FAVoucherDepreciateDetail.vue')
);

const FAVoucherDepreciateResult = defineAsyncComponent(() =>
  import('@/views/assetQLTS/fAVoucherDepreciate/FAVoucherDepreciateResult.vue')
);

const FAVoucherDepreciationResult = defineAsyncComponent(() =>
  import('@/views/assetQLTS/fAVoucherDepreciation/FAVoucherDepreciationResult.vue')
);

const FAVoucherDecrement = defineAsyncComponent(() =>
  import('@/views/assetQLTS/fAVoucherDecrement/FAVoucherDecrement.vue')
);

const FAVoucherDecrementDetail = defineAsyncComponent(() =>
  import('@/views/assetQLTS/fAVoucherDecrement/FAVoucherDecrementDetail.vue')
);

const FAVoucherDecrementResult = defineAsyncComponent(() =>
  import('@/views/assetQLTS/fAVoucherDecrement/FAVoucherDecrementResult.vue')
);

const FAVoucherAdjustment = defineAsyncComponent(() =>
  import('@/views/assetQLTS/fAVoucherAdjustment/FAVoucherAdjustment.vue')
);

const FAVoucherAdjustmentDetail = defineAsyncComponent(() =>
  import('@/views/assetQLTS/fAVoucherAdjustment/FAVoucherAdjustmentDetail.vue')
);

const FAVoucherAdjustmentResult = defineAsyncComponent(() =>
  import('@/views/assetQLTS/fAVoucherAdjustment/FAVoucherAdjustmentResult.vue')
);

const ApproveVoucherQltsVoucher = defineAsyncComponent(() =>
  import('@/views/assetQLTS/popup/ApproveVoucherQltsVoucher.vue')
);

const SyncCategoryDetail = defineAsyncComponent(() =>
  import('@/views/assetQLTS/popup/syncCategory/SyncCategoryDetail.vue')
);

export function registerAssetQLTS(app) {
  app.component('FAResultDeleteDetail', FAResultDeleteDetail);
  app.component('FAVoucherIncreament', FAVoucherIncreament);
  app.component('FAVoucherIncreamentDetail', FAVoucherIncreamentDetail);
  app.component('FAVoucherIncreamentResult', FAVoucherIncreamentResult);
  app.component('FAVoucherDepreciation', FAVoucherDepreciation);
  app.component('FAVoucherDepreciationDetail', FAVoucherDepreciationDetail);
  app.component('FAVoucherDepreciate', FAVoucherDepreciate);
  app.component('FAVoucherDepreciateDetail', FAVoucherDepreciateDetail);
  app.component('FAVoucherDepreciateResult', FAVoucherDepreciateResult);
  app.component('FAVoucherDepreciationResult', FAVoucherDepreciationResult);
  app.component('FAVoucherDecrement', FAVoucherDecrement);
  app.component('FAVoucherDecrementDetail', FAVoucherDecrementDetail);
  app.component('FAVoucherDecrementResult', FAVoucherDecrementResult);
  app.component('FAVoucherAdjustment', FAVoucherAdjustment);
  app.component('FAVoucherAdjustmentDetail', FAVoucherAdjustmentDetail);
  app.component('FAVoucherAdjustmentResult', FAVoucherAdjustmentResult);
  app.component('ApproveVoucherQltsVoucher', ApproveVoucherQltsVoucher);
  app.component('SyncCategoryDetail', SyncCategoryDetail);
}
